<nav class="flex justify-between items-center">
  <ol class="flex items-center gap-2">
    @for (item of items(); track $index) {
      <li
        class="text-surface-950 dark:text-surface-0 text-base whitespace-nowrap"
        [ngClass]="{ 'font-normal cursor-pointer hover:opacity-60': !$last, 'font-medium': $last }"
        [routerLink]="$last ? null : item.routerLink"
        >{{ item.label }}</li
      >
      @if (!$last) {
        <li class="layout-breadcrumb-chevron">/</li>
      }
    }
  </ol>
  @if (support()) {
    <a
      class="ml-2 size-5 text-surface-700 dark:text-surface-100 hover:opacity-60"
      [routerLink]="['/app/guides', support().id.split('/')[0], support().id.split('/')[1]]"
      target="_blank"
      [pTooltip]="support().description"
      tooltipPosition="bottom"
      tooltipStyleClass="min-w-64">
      <i class="pi pi-question-circle"></i>
      <span class="sr-only">{{ support().description }}</span>
    </a>
  }
</nav>
